import Vue from 'vue'

const GET_IMG_CERTIFICATION = 'GET_IMG_CERTIFICATION'
const ADVICE_SHOW_POP = 'ADVICE_SHOW_POP'
const FILTER_TAGS_SHOW = 'FILTER_TAGS_SHOW'
const SHOW_LOADING = 'SHOW_LOADING'
export {
    GET_IMG_CERTIFICATION,
    ADVICE_SHOW_POP,
    FILTER_TAGS_SHOW,
    SHOW_LOADING,
}

export default new Vue()
